export enum EPermissionLevel {
    Never,
    OnlyPublic,
    Always,
}

export const isPermissionLevel = (v: any): v is EPermissionLevel => (
    [EPermissionLevel.Always, EPermissionLevel.Never, EPermissionLevel.OnlyPublic]
        .includes(v)
);

export interface ICategoryPermission {
    id: number;
    categoryId: number;
    roleId: number;
    read: EPermissionLevel;
    edit: EPermissionLevel;
    create: EPermissionLevel;
}

export interface IPermissionDTO {
    id: number;
    tunniste?: string;
    kategoria: number;
    rooli: number;
    luku: string;
    muokkaus: string;
    lisays: string;
}

export interface IAppRoleDTO {
    id: number;
    nimi: string;
    viitenimi: string;
    nayta_nimitiedot: "Y" | "N"
}
